import classNames from 'classnames'
import { ReactElement } from 'react'
import DashboardHeader from 'app/components/analytics/DashboardHeader'
import GeneralRevenueSection from 'app/components/analytics/GeneralRevenueSection'
import { PageScroll } from 'app/components/layout/PageScroll'
import Spinner from 'app/components/Spinner'
import { RevenueDailyMetric, RevenueStatsType } from 'types/analytics'

export type FinancialShadcnComponentProps = {
  openTab: string
  setOpenTab: (tab: string) => void
  locationIds: string[]
  dateRange: { fromDate: string; toDate: string }
  revenueStats: RevenueStatsType | undefined
  isLoading: boolean
  dailyMetrics: RevenueDailyMetric[]
  dateChangeHandler: (
    fromDate: string,
    toDate: string,
    compareFromDate: string,
    compareToDate: string,
    comparingGoals: boolean,
    dontCompare: boolean,
  ) => void
  hideCompare: boolean
}

export function FinancialShadcnComponent({
  openTab,
  setOpenTab,
  locationIds,
  dateRange,
  revenueStats,
  isLoading,
  dailyMetrics,
  dateChangeHandler,
  hideCompare,
}: FinancialShadcnComponentProps): ReactElement {
  return (
    <PageScroll
      contentClassName="pb-14 pt-8"
      header={
        <DashboardHeader
          title="Financial"
          dateChangeHandler={dateChangeHandler}
          limitDateRangeToMonth={true}
          hideCompare={hideCompare}
          defaultDateRange={`last_6_months`}
          allowFutureDates={false}
          hideChannelSelector={true}
        />
      }
    >
      <div className={classNames(openTab === `Summary` ? `block` : `hidden`, `flex flex-col gap-y-12`)}>
        {!revenueStats ? (
          <div className="text-center">
            <Spinner size={10} />
          </div>
        ) : (
          <GeneralRevenueSection
            metrics={revenueStats}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            locationIds={locationIds}
            dailyMetrics={dailyMetrics}
            isLoading={isLoading}
          />
        )}
      </div>
    </PageScroll>
  )
}
